<ng-container *ngIf="isMobile$ | async as isMobile">
  <app-search-bar
    [isMobile]="isMobile"
    [searchType]="searchType"
    [airports]="airports$ | async"
    [source]="source"
    [loadDefaultplaces]="loadDefaultplaces"
    (showMobileCalendarEvent)="showMobileCalendar($event)">
  </app-search-bar>
</ng-container>

<router-outlet name="search"></router-outlet>